export default __webpack_public_path__ + "static/openinfra-days-header-1cd7f3de76cbf8a2522b28ff42099889.png";